import React from 'react';
import { Route, Switch } from 'react-router';

import { getRouteStackPath } from '@portal/config/routes';
import { translate } from '@portal/services/i18n';
import PanelContent from '@portal/components/PanelContent/PanelContent';
import NotificationsPage from './NotificationsPage';

const NotificationsNavigationStack: React.FC = () => {
  return (
    <Switch>
      <Route
        exact
        path={getRouteStackPath('NOTIFICATIONS', 'NOTIFICATIONS_PAGE')}
      >
        <PanelContent
          pageTitle={translate('PAGES.NOTIFICATIONS.TITLE')}
          pageDescription={translate('PAGES.NOTIFICATIONS.DESCRIPTION')}
        >
          <NotificationsPage />
        </PanelContent>
      </Route>
      <Route exact path="/notificacoes">
        <PanelContent
          pageTitle={translate('PAGES.NOTIFICATIONS.TITLE')}
          pageDescription={translate('PAGES.NOTIFICATIONS.DESCRIPTION')}
        >
          <NotificationsPage />
        </PanelContent>
      </Route>
    </Switch>
  );
};

export default NotificationsNavigationStack;
